export enum CategoryLayout {
  NEW_CONCEPT = 'NEW_CONCEPT',
  WIX_INTROS = 'WIX_INTROS',
}
